import { Component } from '@angular/core';
import { FormArray, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ButtonComponent,
	ButtonIconComponent,
	EmptyStateComponent,
	ITagWithLabel,
	ItemComponent,
	ItemGroupComponent,
	LinkComponent,
	ListDetailComponent,
	MenuComponent,
	SwitchComponent,
	TagComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { OPERATION_TYPE } from '../../../../operations/models/operations.models';
import { WorkflowFormOperationPanelBase } from './workflow-form-operation-panel.base';
import { WorkflowFormAdvancedCollapseComponent } from '../workflow-form-advanced-collapse.component';

/**
 * Panel UI de FORM en el editor (NIF-530).
 * Abrir cuando: lista de pasos, ordenación, tutorial o preferencia OCR (NIF-657).
 */
@Component({
	selector: 'app-workflow-form-form-panel',
	imports: [
		WorkflowFormAdvancedCollapseComponent,
		ReactiveFormsModule,
		TranslatePipe,
		TileComponent,
		ItemComponent,
		ItemGroupComponent,
		TagComponent,
		EmptyStateComponent,
		ButtonComponent,
		ButtonIconComponent,
		MenuComponent,
		ListDetailComponent,
		SwitchComponent,
		LinkComponent,
	],
	templateUrl: './workflow-form-form-panel.component.html',
})
export class WorkflowFormFormPanelComponent extends WorkflowFormOperationPanelBase {
	protected readonly operationType = OPERATION_TYPE.FORM;

	public get formStepsArray(): FormArray {
		return this.host.formStepsArray;
	}

	public newFormStep(): void {
		this.host.newFormStep();
	}

	public onFormStepMove(event: unknown, index: number): void {
		this.host.onFormStepMove(event, index);
	}

	public formStepsMenuChange(event: unknown, index: number): void {
		this.host.formStepsMenuChange(event, index);
	}

	public getFormStepListTags(stepIndex: number): ITagWithLabel[] {
		return this.host.getFormStepListTags(stepIndex);
	}

	public resolveFormStepPresetTypeLabel(stepIndex: number): string {
		return this.host.resolveFormStepPresetTypeLabel(stepIndex);
	}

	public resolveFormStepListTitle(stepIndex: number): string {
		return this.host.resolveFormStepListTitle(stepIndex);
	}

	public shouldShowFormOcrOrderItem(): boolean {
		return this.host.shouldShowFormOcrOrderItem();
	}

	public isFormOcrOrderAutofill(): boolean {
		return this.host.isFormOcrOrderAutofill();
	}

	public isFormOcrOrderAutofillConfirmed(): boolean {
		return this.host.isFormOcrOrderAutofillConfirmed();
	}

	public openFormOcrOrderEdit(): void {
		this.host.openFormOcrOrderEdit();
	}
}
